import type { length } from "../Types/Length";
import type source from '../Types/Source';

/**
 * Check if a string is a valid element selector.
 */
const isSelector = (selector :string) :boolean => {
    try {
        document.querySelector(selector);
        return true;
    } catch {
        return false;
    }
}

/**
 * Parse a length into px (int) or get top offset of an element.
 */
const toPx = (lengthOrSelector :length|string, relation ?:number) :number => {
    if (isSelector(lengthOrSelector)) {
        const node = toNode(lengthOrSelector);
        if (!node || !('getBoundingClientRect' in node)) {
            return 0;
        }
        return node.getBoundingClientRect().top + window.scrollY;
    }
    const m :RegExpMatchArray|null = lengthOrSelector.match(/^\s*(?<value>[+-]?(?:\d{1,3}(?:[.,]\d{3})+|\d+)(?:[.,]\d+)?)[\s]*(?<unit>[%A-Za-z€$£¥°µμ]+)?/);
    if (!m) {
        return parseInt(lengthOrSelector);
    }
    const unit  :string = m.groups?.unit || '';
    const value :string = m.groups?.value || '';
    if ('%' === unit) {
        if (relation) {
            return relation * (parseInt(value) / 100);
        }
        return window.innerHeight * (parseInt(value) / 100);
    }
    if ('vh' === unit) {
        return window.innerHeight * (parseInt(value) / 100);
    }
    if ('vw' === unit) {
        return window.innerWidth * (parseInt(value) / 100);
    }
    return parseInt(value);
}


/**
 * Normalize a source, which can be quite anything, to an element or window.
 */
const toElementOrWindow = (source: source) :Element|Window|null => {
    if (source instanceof Element) {
        return source as Element;
    }
    if (Window === source.constructor) {
        return source as Window;
    }
    if (NodeList === source.constructor && source.length) {
        return source[0] as Element;
    }
    if (isSelector(source as string)) {
        return document.querySelector(source.toString()) as Element;
    }
    return null;
}

/**
 * TODO: Replace all uses of this with toElementOrWindow()
 * @param source
 */
const toNode = (source :source) :Element|Window|null => {
    return toElementOrWindow(source);
}

export {
    isSelector,
    toElementOrWindow,
    toNode, // TODO: Remove in the future, just kept it because it's still in use
    toPx,
}